

export namespace DomUtils {

    /**
 * Simple object check.
 * @param item
 * @returns {boolean}
 */
    function isObject(item) {
        return (item && typeof item === 'object' && !Array.isArray(item));
    }

    /**
     * Deep merge two objects.
     * @param target
     * @param ...sources
     */
    export function mergeDeep(target, ...sources) {
        if (!sources.length) return target;
        const source = sources.shift();

        if (isObject(target) && isObject(source)) {
            for (const key in source) {
                if (isObject(source[key])) {
                    if (!target[key]) Object.assign(target, { [key]: {} });
                    mergeDeep(target[key], source[key]);
                } else {
                    Object.assign(target, { [key]: source[key] });
                }
            }
        }

        return mergeDeep(target, ...sources);
    }

    export function inViewport(element: HTMLElement) {
        const rect = element.getBoundingClientRect();
        return (
            rect.top >= 0 &&
            rect.left >= 0 &&
            rect.bottom <= (window.innerHeight || window.document.documentElement.clientHeight) &&
            rect.right <= (window.innerWidth || window.document.documentElement.clientWidth)
        );
    }

    export function pressedNumber(event: any) {
        return event.charCode >= 48 && event.charCode <= 57
    }

    export function pastedNumber(event: any, stepSize: number) {
        var clipboardData, pastedData;

        // Stop data actually being pasted into div
        event.stopPropagation();
        event.preventDefault();

        // Get pasted data via clipboard API
        clipboardData = event.clipboardData || window['clipboardData'];
        pastedData = clipboardData.getData('Text');
        if (isNaN(+pastedData))
            return false;
        return +pastedData % stepSize == 0;
    }

    export function openDialogAsModal(id: string) {
        ((window as any)[id] as any).showModal();
    }

    export function clearChildren(elm: HTMLElement): void {
        if (elm == null)
            return;
        if (!(elm?.childNodes?.length > 0))
            return;
        elm.childNodes.forEach(node => elm.removeChild(node));
    }

    export function createTag<K extends keyof HTMLElementTagNameMap>(tagName: K, attributes?: { [keyof: string]: string }): HTMLElementTagNameMap[K] {
        var elm = document.createElement(tagName);
        if (attributes)
            addAttributes(elm, attributes);
        return elm;
    }

    export function addAttributes(elm: HTMLElement, attributes: { [keyof: string]: string }): void {
        Object
            .entries(attributes)
            .forEach(([attributeName, attributeValue]) => attributeValue != null && attributeValue != 'null' ? elm.setAttribute(attributeName, attributeValue) : elm.removeAttribute(attributeName));
    }
}
